import Page5 from '../../features/ServiciosAnalisisDeDatos.feature/Page5';

export default function ServiciosAnalisisDeDatos() {
  return (
    <>
      <Page5 />
    </>
  );
}
